import { SWReactIcons } from "@similarweb/icons";
import { SidebarDropDownItem, SidebarDropDownLink } from "app/components/SideBar/StyledComponents";
import styled from "styled-components";
import "./UserSettingsDropdown.scss";

export const Button = styled(SWReactIcons)`
    display: inline-block;
    width: 36px;
    height: 36px;
    cursor: pointer;
    position: relative;
    transition: all ease 300ms;
    &:hover {
        path {
            fill: #ffffff;
        }
    }
`;

export const UserSettingsDropDownItem = styled(SidebarDropDownItem)``;
UserSettingsDropDownItem.displayName = "UserSettingsDropDownItem";

export const UserSettingsDropDownLink = styled(SidebarDropDownLink)``;
UserSettingsDropDownLink.displayName = "UserSettingsDropDownLink";

export const logout = (loginUrl: string): void => {
    window.location.href = `${loginUrl}/logout`;
};
